// extracted by mini-css-extract-plugin
export default {"table__pagination":"BulkTablePagination_table__pagination__UK8iI"};